import { LoadingDot } from '../../../../components/loading-dot';
import { UserPrivateAccountSubscriptionsModel } from './model';

export class UserPrivateAccountSubscriptionsView {
  static instance;

  constructor() {
    if (UserPrivateAccountSubscriptionsView.instance) {
      throw new Error('Clase singleton')
    }
    this.model = UserPrivateAccountSubscriptionsModel.getInstance();
  }

  static getInstance() {
    if (!UserPrivateAccountSubscriptionsView.instance) {
      UserPrivateAccountSubscriptionsView.instance = new UserPrivateAccountSubscriptionsView();
    }
    return UserPrivateAccountSubscriptionsView.instance;
  }


  async renderChangePlanWindow(_planObj, _status, _statusActive, _planActive, _plan) {

    let html = `
      <h2>Plan actual:</h2>
      <h3 class="mb0">${_planActive.optionText} </h3>
      <br>
      ${(_planActive.title == 'Gratuito' ? '' : _statusActive.description + '<br>')}
      ${(_planActive.title != 'Gratuito' && _plan.statusActiveId != 4 ? '<button class="mt20 bg-red" onclick="app.userPrivateController.account.subscriptions.cancelPlan()">Desuscribirme</button>' : '')}
    `;

    if (_planActive.idcod != _planObj.idcod && _planObj.title != "Gratuito") {
      let plan = await this.model.getMPStatus();
      let returnButton = '';
      if (plan && plan.init_point) {
        returnButton = `
          <button class="mt20 bg" onclick="app.buttons.lock(this, 'Redireccionando', true); app.buttons.hideById('cancel-subscription'); window.location.href='${plan.init_point}';">Continuar la operación en Mercado Pago</button>
        `;
      }
      html += `
        <hr>
        <h2>Plan en proceso:</h2>
        <h3 class="mb0">${_planObj.title} </h3>
        <br>
        <span style="font-weight: 100; font-size:13px; color:dimgray">${_status.description}<span>
        <br>
        ${returnButton}
        <button class="mt20 bg-red" id="cancel-subscription" onclick="app.userPrivateController.account.subscriptions.cancelPlan()">Cancelar</button>
      `;
    } else {
      html += `
        <hr>
        <h2>Editar plan:</h2>
        Seleccione su nuevo plan:
        <select id="new-plan" style="width: 100%;"></select>
        <button class="mt20" onclick="app.userPrivateController.account.subscriptions.changePlan()">Activar nuevo plan</button>
      `;
    }

    html += `
        <hr>
        Ante cualquier inquietud con el servicio de suscripciones, puede contactarnos a <a href="mailto:planes@agrolabores.com">planes@agrolabores.com</a> y atenderemos su consulta. 
        `;

    return html;
  }


  renderBackMP() {
    return `
      <b>¡Ya estas de vuelta!</b>
      <br>
      En unos minutos terminaremos de revisar tu pago. 
      <br>
      Tu plan se activará automáticamente, te estaremos avisando.
      <br>
      <button class="mt20" onclick="window.location.href='/user/account'">Continuar a tu cuenta</button>
    `;
  }

  renderChangePlanConfirmation(_planObj) {
    return `
      <h2>Nuevo plan:</h2>
      <b>${_planObj.title}</b>
      <br>
      Para adquirir el nuevo plan, lo redireccionaremos a Mercado Pago.
      <br>
      <br>
      <h3>¿Seguro desea cambiar de plan?</h3>
      <button class="mt20" onclick="app.buttons.lock(this, 'Redireccionando', true); app.buttons.hideById('cancel-subscription'); app.userPrivateController.account.subscriptions.changePlanConfirmation('${_planObj.idcod}')">Si, continuar a Mercado Pago</button>
      <button class="mt20 bg-red" id="cancel-subscription" onclick="app.userPrivateController.account.subscriptions.closeConfirmationModal()">Cancelar</button>
      <div id="new-plan-status"></div>
    `;
  }

  renderCancelPlanWindow(_planActive, _status) {
    let html = `
      <h2>Plan actual:</h2>
      <b>${_planActive.title}</b>
      <br>
      ${_planActive.optionText}
      <hr>
      <h2>¿Seguro desea cancelar su subscripción a este plan?</h2>
      <button class="mt20 bg-red" onclick="app.buttons.lock(this, 'Cancelando suscripción', true); app.userPrivateController.account.subscriptions.cancelPlanConfirmation()">Cancelar subscripción</button>
      <div id="cancel-plan-status"></div>
    `;
    return html;
  }
}
